export type CallbackRouteNoContext = {
  path: 'callbacks/google_callback';
};

export type CallbackRoute = CallbackRouteNoContext & {
  context: {
    redirect?: string;
    oauthKey?: string;
  };
};

function parseContext(params: URLSearchParams): CallbackRoute['context'] {
  const redirect = params.get('redirect') || undefined;
  if (redirect != null) {
    if (redirect.startsWith('//') || !redirect.startsWith('/')) {
      throw new Error('Invalid insecure redirect');
    }
  }
  const oauthKey = params.get('oauthKey') || undefined;
  return {
    redirect,
    oauthKey,
  };
}

export function maybeParseCallbackRoute(
  url: Pick<URL, 'searchParams' | 'pathname'>,
): CallbackRoute | undefined {
  const p = url.searchParams;
  if (url.pathname === '/app/callbacks/google_callback') {
    return {
      path: 'callbacks/google_callback',
      context: parseContext(p),
    };
  }
}
